import TkHelpIcon from "../../components/atoms/TkHelpIcon";

const stepperData = ["事前確認", "提出内容確認", "掛金の確認", "機構へ提出"];

const tableHeadList: any = [
  {
    headTitle: (
      <>
        施設名称
        <TkHelpIcon
          helpMessage={
            <>
              掛金納付対象職員届の対象となる施設等の名称です。全施設の表示があることを確認してください。
            </>
          }
        />
      </>
    ),
    className: "facilityName",
    align: "center",
  },
  {
    headTitle: (
      <>
        種類
        <TkHelpIcon
          helpMessage={
            <>現在登録されている施設等の施設種類・サービス種類です。</>
          }
        />
      </>
    ),
    className: "type",
    align: "center",
  },
  {
    headTitle: (
      <>
        区分
        <TkHelpIcon
          helpMessage={
            <>
              施設種類・サービス種類に応じた施設区分を表示しています。
              <br />
              施設区分に応じて掛金が変わります。
              <br />
              詳しくは
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫施設区分について.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                こちら
              </a>
              をご確認ください。
            </>
          }
        />
      </>
    ),
    className: "classification",
    align: "center",
  },
  {
    headTitle: (
      <>
        掛金納付対象職員数
        <TkHelpIcon
          helpMessage={
            <>当年度の掛金の対象となる人数について施設ごとに表示しています。</>
          }
        />
      </>
    ),
    className: "numberOfStaff",
    align: "center",
  },
  {
    headTitle: "単位掛金額対象職員数",
    className: "unitCreditCost",
    align: "center",
  },
  {
    headTitle: "単位掛金額×3対象職員数",
    className: "unitCreditCostThreeTimes",
    align: "center",
  },
  {
    headTitle: (
      <>
        掛金額
        <TkHelpIcon
          helpMessage={
            <>
              <div>
                当年度の掛金について納付いただく額を施設ごとに表示しています。
              </div>
              ※福祉医療機構の退職共済掛金の会計処理は、費用処理することとなります。退職給付引当金には計上しません。
            </>
          }
        />
      </>
    ),
    className: "premium",
    align: "center",
  },
];

export { stepperData, tableHeadList };
